export default __webpack_public_path__ + "static/media/purple-calendar.a61d1587.svg";